import React from "react";
import PropTypes from "prop-types";
import { dateFormatter } from "../../../../../../utils/commonUtil";
import { UnderlyingContent } from "../../style";
import { ScheduleLabel, CustomSectionLabel } from "./style";

const getPendingText = ({
  agreements,
  history,
  grantActivityClick,
  grantDetailsHandler,
}) => {
  switch (agreements.length) {
    case 1:
      return (
        <CustomSectionLabel>
          {`You have ${agreements.length} ${
            history ? "" : "active"
          } grant agreement `}
          <UnderlyingContent
            id="anrgrantAgreementDetails"
            onClick={() => grantDetailsHandler(agreements[0].id)}
          >
            {`(Agreement ID: ${agreements[0].id})`}
          </UnderlyingContent>
          {` with ${
            agreements[0].remainingPayments
          } pending payment(s) until ${dateFormatter(agreements[0].endDate)}`}
        </CustomSectionLabel>
      );
    case 0:
      return (
        <CustomSectionLabel>
          {`You have no ${history ? "" : "active"} grant agreement.`}
        </CustomSectionLabel>
      );
    default:
      return (
        <CustomSectionLabel>
          {`You have ${agreements.length} ${
            history ? "" : "active"
          } grant agreement. `}
          <UnderlyingContent
            id="anrViewGrantActivityAgreement"
            onClick={grantActivityClick}
          >
            View Grant Activity
          </UnderlyingContent>
        </CustomSectionLabel>
      );
  }
};

export default function AgreementSection({
  agreements,
  history,
  grantActivityClick,
  grantDetailsHandler,
}) {
  const sectionTitle = history ? "Grant Agreement" : "Active Grant Agreement";
  return (
    <>
      <ScheduleLabel>{sectionTitle}</ScheduleLabel>
      {getPendingText({
        agreements,
        history,
        grantActivityClick,
        grantDetailsHandler,
      })}
    </>
  );
}

AgreementSection.propTypes = {
  agreements: PropTypes.arrayOf(
    PropTypes.shape({
      endDate: PropTypes.string,
      id: PropTypes.number,
      remainingPayments: PropTypes.number,
    })
  ),
  history: PropTypes.any,
  grantActivityClick: PropTypes.func,
  grantDetailsHandler: PropTypes.func,
};
